"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefHighLowHowToInterpret = void 0;
var RefHighLowHowToInterpret;
(function (RefHighLowHowToInterpret) {
    RefHighLowHowToInterpret["BetweenAndEquals"] = "low <= value >= high";
    RefHighLowHowToInterpret["BetweenAndNotEquals"] = "low < value > high";
    RefHighLowHowToInterpret["BetweenAndEqualsLow"] = "low <= value > high";
    RefHighLowHowToInterpret["BetweenAndEqualsHigh"] = "low < value >= high";
    RefHighLowHowToInterpret["Below"] = "refLow < value";
    RefHighLowHowToInterpret["BelowAndEquals"] = "refLow <= value";
    RefHighLowHowToInterpret["High"] = "value > high";
    RefHighLowHowToInterpret["HighAndEquals"] = "value >= high";
})(RefHighLowHowToInterpret || (exports.RefHighLowHowToInterpret = RefHighLowHowToInterpret = {}));
//# sourceMappingURL=ref-high-low-how-to-interpret.enum.js.map